module.exports = "/images/demo_mand.png?94b41213306520d36b3a772970bbf079";